import { create } from "zustand";

export type AppTheme = "light-flat" | "dark" | "gradient-light";

interface ThemeState {
  theme: AppTheme;
  setTheme: (theme: AppTheme) => void;
}

const storageKey = "eshendetesia.theme";

const readInitialTheme = (): AppTheme => {
  if (typeof window === "undefined") {
    return "gradient-light";
  }

  const stored = window.localStorage.getItem(storageKey);
  if (stored === "light-flat" || stored === "dark" || stored === "gradient-light") {
    return stored;
  }

  return "gradient-light";
};

export const useThemeStore = create<ThemeState>((set) => ({
  theme: readInitialTheme(),
  setTheme: (theme) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(storageKey, theme);
    }
    set({ theme });
  },
}));
